import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { reportQueryOptions, reportSearchDeps } from '@/hooks/use-report'

// Pathless layout that OWNS the report key, so an ámbito or Detailed/Summary switch re-keys THIS match and not the
// page above it — which paints its skeleton at `pendingMs: 0` and would replace the report being read. No
// component: nothing to code-split, nothing painted on a re-key. market.tsx reads it with `useMatch({ from })`.
export const Route = createFileRoute('/_app/market/_report')({
  loaderDeps: ({ search }) => reportSearchDeps(search),
  context: ({ deps, params }) => ({
    reportQueryOptions: reportQueryOptions(deps, params, 'market'),
  }),
  loader: ({ context }) => {
    if (context.reportQueryOptions) context.queryClient.query(context.reportQueryOptions).catch(noop)
  },
})
